// export default 'https://ppid-undip.fosan.id/api/';

export default 'https://ppid.apps.undip.ac.id/api/';

// export default 'http://localhost:5000/';